import { render } from "./EducationComponent.vue?vue&type=template&id=53a400cb&scoped=true"
const script = {}

import "./EducationComponent.vue?vue&type=style&index=0&id=53a400cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a400cb"]])

export default __exports__